module.exports = __webpack_public_path__ + "img/2.a54bdc59.png";